
// initial state
const state = {
	productsList: [],
	scannedBarcode: []
}

// getters
const getters = {
	getProductsList: state => state.productsList,
	getScannedBarcode: state => state.scannedBarcode
}

// actions
const actions = {
	setProductsList ({ commit }, values) {
		commit('SET_PRODUCTS_LIST', values)
	},
	setScannedBarcode ({ commit }, values) {
		commit('SET_SCANNED_BARCODE', values)
	},
	pushScannedBarcode ({ commit }, values) {
		commit('PUSH_SCANNED_BARCODE', values)
	},
	incrementScannedBarcode ({ commit }, values) {
		commit('INCREMENT_SCANNED_BARCODE_ITEM', values)
	},
	decrementScannedBarcode ({ commit }, values) {
		commit('DECREMENT_SCANNED_BARCODE_ITEM', values)
	},
	spliceScannedBarcode ({ commit }, values) {
		commit('SPLICE_SCANNED_BARCODE', values)
	},
	clearScannedBarcode ({ commit }) {
		commit('CLEAR_SCANNED_BARCODE')
	},
	/**
	 * 端末情報を保持する
	 * @param  {ActionContext} commit vuexのaction指定
	 * @param  {Object} values Navigatorオブジェクト
	 */
	setNavigator ({ commit }, values) {
		commit('SET_NAVIGATOR', values)
	}
}

// mutations
const mutations = {
	/**
	 * 商品情報を保持する
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values 商品リストの配列
	 */
	'SET_PRODUCTS_LIST' (state, values) {
		state.productsList = values
	},
	/**
	 * スキャンした商品情報を保持する
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values 商品の配列
	 */
	'SET_SCANNED_BARCODE' (state, values) {
		state.scannedBarcode = values || []
	},
	/**
	 * スキャンした商品を追加する
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values 商品オブジェクト
	 */
	'PUSH_SCANNED_BARCODE' (state, values) {
		state.scannedBarcode.push(values)
	},
	/**
	 * スキャンした商品の個数を増やす
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values 商品のインデックス
	 */
	'INCREMENT_SCANNED_BARCODE_ITEM' (state, values) {
		state.scannedBarcode[values].quantity += 1
	},
	/**
	 * スキャンした商品をの個数を減らす
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values 商品のインデックス
	 */
	'DECREMENT_SCANNED_BARCODE_ITEM' (state, values) {
		state.scannedBarcode[values].quantity -= 1
	},
	/**
	 * 任意のスキャンした商品を削除する
	 * @param  {Object} state このモジュールのstate
	 * @param  {Object} values 商品のインデックス
	 */
	'SPLICE_SCANNED_BARCODE' (state, values) {
		state.scannedBarcode.splice(values, 1)
	},
	/**
	 * スキャンした商品をすべて削除する
	 * @param  {Object} state このモジュールのstate
	 */
	'CLEAR_SCANNED_BARCODE' (state) {
		// console.log('values', values)
		state.scannedBarcode = []
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
